import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFormRegisterResultActionTypes } from "../../action-types/form/IFormRegisterResultActionTypes";
import { IFormRegisterResultReducer } from "../../page-state-model/form/IFormRegisterResultReducer";
const iniState: IFormRegisterResultReducer = {
    status: ePageBaseStatus.is_not_initialization,
    formRegisterResults: [],
    formRegisterResultVms: [],
}
export const formRegisterResultReducer = (state: IFormRegisterResultReducer = iniState, action: IFormRegisterResultActionTypes): IFormRegisterResultReducer => {
    switch (action.type) {
        case "FORM_REGISTER_RESULT_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "FORM_REGISTER_RESULT_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formRegisterResults: action.payload
            }
        case "FORM_REGISTER_RESULT_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formRegisterResults: []
            }
        case "FORM_REGISTER_RESULT_LOAD_COSO_CHIENDICH_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "FORM_REGISTER_RESULT_LOAD_COSO_CHIENDICH_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formRegisterResultVms: action.payload
            }
        case "FORM_REGISTER_RESULT_LOAD_COSO_CHIENDICH_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formRegisterResultVms: []
            }
        case "FORM_REGISTER_RESULT_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "FORM_REGISTER_RESULT_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "FORM_REGISTER_RESULT_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "FORM_REGISTER_RESULT_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "FORM_REGISTER_RESULT_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "FORM_REGISTER_RESULT_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "FORM_REGISTER_RESULT_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "FORM_REGISTER_RESULT_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "FORM_REGISTER_RESULT_SAVE_ATTENDANCE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "FORM_REGISTER_RESULT_SAVE_ATTENDANCE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "FORM_REGISTER_RESULT_SAVE_ATTENDANCE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "FORM_REGISTER_RESULT_UPDATE_HOCSINH_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "FORM_REGISTER_RESULT_UPDATE_HOCSINH_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "FORM_REGISTER_RESULT_UPDATE_HOCSINH_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "FORM_REGISTER_RESULT_UPDATE_RESULT_START":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "FORM_REGISTER_RESULT_UPDATE_RESULT_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "FORM_REGISTER_RESULT_UPDATE_RESULT_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "FORM_REGISTER_RESULT_UPDATE_STATUS_START":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "FORM_REGISTER_RESULT_UPDATE_STATUS_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "FORM_REGISTER_RESULT_UPDATE_STATUS_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        default:
            return state;
    }
}